import styled from 'styled-components';
import { mediaQuery } from '../../utils';
import { Flex } from '../flex';
import { theme } from '../theme';

export const StyledPageWithTable = styled(Flex)`
  width: 100%;
  margin-top: 3rem;
`;

export const StyledWrapper = styled.div`
  width: 100%;
  .empty {
    margin-bottom: -1.813rem;

    ${mediaQuery('md')} {
      margin-bottom: 3rem;
    }
  }
`;

export const StyledFilterWindow = styled.div`
  min-width: 250px;
  min-height: 100px;
  position: absolute;
  border: 1px ${({theme}) => theme.colors.primaryK10} solid;
  background-color: ${({theme}) => theme.colors.primaryW};
  border-radius: 5px;
`;

export const StyledFilterWindowTitle = styled.div`
  min-height: 40px;
  width: 100%;
  background-color: ${({theme}) => theme.colors.primaryK8};
  border-radius: 5px 5px 0 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
  svg {
    height: 12px;
    width: 12px;
    margin: 2px 5px 0 0;
  }
  h5 {
    margin: unset;
    line-height: 40px;
    padding-left: 10px;
  }
`;

export const StyledFilterWindowBody = styled.div`
  height: 75%;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const StyledFilterWindowSort = styled.div`
  svg {
    height: 12px;
    width: 12px;
  }
`;

export const CheckboxHolder = styled.div`
  justify-content: start;
  align-content: start;
  display: flex;
  flex-direction: column;
  font-weight: normal;
  overflow-y: auto;
  max-height: 200px;
`;

export const StyledFilterWindowButtonSortHolder = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
`;

export const LabelSort = styled.h5`
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h5-font-size);
  line-height: var(--h5-line-height);
  color: ${({theme}) => theme.colors.primaryK7};
  text-transform: uppercase;
  text-align: start;
`;

export const StyledFilterWindowFooter = styled.div`
  min-height: 50px;
  width: 100%;
  border-top: ${({theme}) => theme.colors.primaryK1} 1px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;

  svg {
    height: 12px;
    width: 12px;
    margin: 2px 5px 0 0;
  }
  button {
    font-size: 0.8rem;
    padding: 1rem;
    height: 2rem;
    min-height: unset;
  }
`;

export const StyledTableUtils = styled.div`
  width: 100%;
  justify-content: space-between;
  display: inline-flex;
  padding: 0 0 1rem 0;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  ${mediaQuery('md')} {
    width: 22.5rem;
  }
`;

export const ButtonWrapper = styled.div`
  border: 2px solid ${({theme}) => theme.colors.primaryT2};
  border-radius: 5px;
  padding: 3px 15px;
  display: inline-block;
`;

export const StyledNavigationFlex = styled.div`
  width: 100%;
  margin: 1rem 0;

  ${mediaQuery('md')} {
    div:first-child {
      align-items: flex-end;
    }
  }
`;

export const PageHeader = styled.div`
  margin: 2rem 0;
  display: flex;
`;

export const InfoMessageWrapper = styled.div`
  margin-top: 1rem;

  ${mediaQuery('md')} {
    max-width: 40rem;
  }
`;

export const SearchUnavailableHelperText = styled.div`
  padding-left: 10px;
  display: flex;
`;

export const AppliedFiltersHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-bottom: 10px;
`;

export const FilterHolder = styled.div`
  display: none;
  ${mediaQuery('md')} {
    display: unset;
  }
`;
